module.exports = __webpack_public_path__ + "img/menu4_hover.7e339c6b.png";